import React from 'react';

interface DoctorBusyProps {
  isOpen: boolean;
  onClose: () => void;
}

const DoctorBusy: React.FC<DoctorBusyProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg p-6 max-w-sm text-center shadow-lg">
        <h2 className="text-2xl font-semibold mb-4">Info</h2>
        <p className="text-gray-700 mb-6">
          Maaf, slot konsultasi dokter sedang penuh saat ini. Mohon tunggu sebentar, Anda akan segera dilayani saat slot dokter tersedia kembali.
        </p>
        <button
          onClick={onClose}
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default DoctorBusy;
